import * as types from '../actions/actionTypes';

const initialState = {
    details: {
        loading: false,
        success: true,
        data: {}
    },
    updateCampaignDetails: {
        loading: false,
        success: true,
        message: ''
    },
    lists: {
        newList: {
            loading: false,
            success: true,
            message: ''
        },
        allLists: {
            loading: false,
            success: true,
            data: []
        },
        approve: {
            loading: false,
            success: true,
            message: ''
        },
        resendMessage: {
            loading: false,
            success: true
        },
        externalUpdates: {
            loading: false,
            success: true,
            data: {}
        },
        verifyUpdates: {
            loading: false,
            success: true
        }
    },
    individuals: {
        newIndividual: {
            loading: false,
            success: true,
            message: ''
        },
        allIndividuals: {
            loading: false,
            success: true,
            data: []
        }
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_CAMPAIGN_DETAILS:
            return Object.assign({}, state, { details: { ...initialState.details, loading: true } });
        case types.GET_CAMPAIGN_DETAILS:
            return Object.assign({}, state, { details: action.response });
        case types.CLEAR_CAMPAIGN_DETAILS:
            return Object.assign({}, state, { details: initialState.details });

        case types.START_UPDATE_CAMPAIGN_DETAILS:
            return Object.assign({}, state, { updateCampaignDetails: { ...initialState.updateCampaignDetails, loading: true } });
        case types.UPDATE_CAMPAIGN_DETAILS:
            return Object.assign({}, state, {
                updateCampaignDetails: { loading: false, success: action.response.success, message: action.response.message },
                details: { ...state.details, data: action.response.success ? action.response.data : state.details.data }
            });

        case types.START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL:
            return Object.assign({}, state, { individuals: { ...state.individuals, ...{ newIndividual: { ...initialState.newIndividual, loading: true } } } });
        case types.ADD_CAMPAIGN_DETAILS_INDIVIDUAL:
            return Object.assign({}, state, {
                individuals: {
                    ...state.individuals, ...{
                        newIndividual: { success: action.response.success, loading: action.response.loading, message: action.response.message }
                    }
                }
            });

        case types.START_GET_CAMPAIGN_ALL_LISTS:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ allLists: { ...initialState.lists.allLists, loading: true } } } });
        case types.GET_CAMPAIGN_ALL_LISTS:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ allLists: action.response } } });
        case types.START_GET_CAMPAIGN_ALL_INDIVIDUALS:
            return Object.assign({}, state, { individuals: { ...state.individuals, ...{ allIndividuals: { ...initialState.individuals.allIndividuals, loading: true } } } });
        case types.GET_CAMPAIGN_ALL_INDIVIDUALS:
            return Object.assign({}, state, { individuals: { ...state.individuals, ...{ allIndividuals: action.response } } });

        case types.START_ADD_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ newList: { ...initialState.newList, loading: true } } } });
        case types.ADD_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, {
                lists: {
                    ...state.lists, ...{
                        newList: { success: action.response.success, loading: action.response.loading, message: action.response.message }
                    }
                }
            });

        case types.START_APPROVE_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ approve: { ...initialState.approve, loading: true } } } });
        case types.APPROVE_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ approve: action.response } } });

        case types.START_RESEND_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ resendMessage: { ...initialState.resendMessage, loading: true } } } });
        case types.RESEND_CAMPAIGN_DETAILS_LIST:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ resendMessage: action.response } } });

        case types.START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ externalUpdates: { ...initialState.externalUpdates, loading: true } } } });
        case types.GET_CAMPAIGN_LIST_EXTERNAL_UPDATES:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ externalUpdates: action.response } } });

        case types.START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ verifyUpdates: { ...initialState.verifyUpdates, loading: true } } } });
        case types.VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES:
            return Object.assign({}, state, { lists: { ...state.lists, ...{ verifyUpdates: action.response } } });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CampaignDetailsReducer.js